import Auth0Lock from 'auth0-lock';
import Vue from 'vue';
import { FoxEnvs } from './foxeriot_environments';

let loginLogo = require('../../assets/img/iniot.png');

let lock = new Auth0Lock(
    FoxEnvs.prod.authClientId,
    FoxEnvs.prod.authDomain,
    {
        autoclose: true,
        redirect: false,
        auth: {
            audience: FoxEnvs.prod.publicApiAudience,
            params: {
                scope: "openid email"
            },
            responseType: "token id_token"
        },
        oidcConformant: true,
        theme: {
            logo: loginLogo,
            primaryColor: '#EA3927'
        },
        language: 'fi',
        languageDictionary: {
            title: "Raportointi"
        },
    }
);

let auth = new Vue({
    data: function()  {
        return {
            token: {
                get: function() {
                    return localStorage.getItem('id_token');
                },
                set: function(id_token) {
                    localStorage.setItem('id_token', id_token);
                }
            },
            accessToken: {
                get: function() {
                    return localStorage.getItem('access_token');
                },
                set: function(accessToken) {
                    localStorage.setItem('access_token', accessToken)
                }
            },
            expirationTime: {
                get: function() {
                    return localStorage.getItem('expiration_time');
                },
                set: function(expiresIn) {
                    localStorage.setItem('expiration_time', expiresIn);
                }
            },
            user: {
                get: function() {
                    return JSON.parse(localStorage.getItem('user'));
                },
                set: function(user) {
                    localStorage.setItem('user', JSON.stringify(user));
                }
            },
            userEmail: {
                get: function() {
                    return JSON.parse(localStorage.getItem('userEmail'));
                },
                set: function(userEmail) {
                    localStorage.setItem('userEmail', JSON.stringify(userEmail));
                }
            },
            profile: {
                get: function() {
                    return JSON.parse(localStorage.getItem('profile'));
                },
                set: function(profile) {
                    localStorage.setItem('profile', JSON.stringify(profile));
                }
            }
        }
    },
    methods: {
        login() {
            lock.show();
        },
        getAuthToken() {
            return this.accessToken.get();
        },
        setAuthToken(token) {
            this.accessToken.set(token);
        },
        logout() {
            return new Promise((resolve) => {
                this.expirationTime.set(null);
                this.accessToken.set(null);
                this.token.set(null);
                this.user.set(null);
                this.profile.set(null);

                /*It just works...*/
                let for_the_auth_trigger = this.expirationTime;
                this.expirationTime = null;
                this.expirationTime = for_the_auth_trigger;

                localStorage.clear();
                sessionStorage.clear();
                resolve(lock);
            });
        },
        isAuthenticated() {
            return new Date().getTime() < this.expirationTime.get();
        },
        handleAuthentication(authResult) {
            if (authResult && authResult.accessToken && authResult.idToken) {
                this.expirationTime.set(authResult.expiresIn * 1000 + new Date().getTime());
                this.accessToken.set(authResult.accessToken);
                this.token.set(authResult.idToken);
                this.user.set(authResult.idTokenPayload);

                this.userEmail.set(authResult.idTokenPayload.email);

                /*It just works...*/
                let for_the_auth_trigger = this.expirationTime;
                this.expirationTime = null;
                this.expirationTime = for_the_auth_trigger;

                lock.getUserInfo(authResult.accessToken, (error, profile) => {
                    if (error) {
                        console.error("getUserInfo failed: ", error);
                        return;
                    }
                    else {
                        this.profile.set(profile);
                    }
                });
                lock.hide();
            }
            else if (this.isAuthenticated())
            {
                lock.hide();
            }
            else
            {
                this.logout();
            }
        }
    }
});
lock.on('authenticated', function(result) {
    auth.handleAuthentication(result);
});
lock.on('authorization_error', function(error) {
    lock.show({
        flashMessage: {
            type: 'error',
            text: error.error_description
        }
    });
});
export default {
    install: function(Vue) {
        Vue.prototype.$auth = auth;
    }
}




// WEBPACK FOOTER //
// ./src/app/service/AuthService.js